import React, { Component } from 'react';
import ko from 'knockout';
import 'devexpress-reporting/dx-webdocumentviewer';
import '../../../src/ManifestReport.css';



export class ManifestReportViewer extends Component {
    constructor(props) {
        super(props);

        this.history = props.history;
        
        var manifestNumber = props.manifestNumber;
        var carrierId = props.carrierId;
         //this.reportUrl = ko.observable('?manifestNumber=' + manifestNumber + '&carrierId=' + carrierId);
        this.reportUrl = ko.observable('?manifestNumber=' + manifestNumber + '&carrierId=' + carrierId);
        this.requestOptions = {
            host: "https://localhost:44353/",
            // Use this line for the ASP.NET MVC backend.
            //invokeAction: "/WebDocumentViewer/Invoke"
            // Use this line for the ASP.NET Core backend
            invokeAction: "DXXRDV"
        };
    }
    render() {
        return (<div ref="viewer" data-bind="dxReportViewer: $data"></div>);
    }
    componentDidMount() {
        ko.applyBindings({
            reportUrl: this.reportUrl,
            requestOptions: this.requestOptions
        }, this.refs.viewer);
    }
    componentWillUnmount() {
        ko.cleanNode(this.refs.viewer);
    }
}